export const FETCH_PORTUGUESES = 'FETCH_PORTUGUESES';
export const FETCH_PORTUGUESES_FULFILLED = 'FETCH_PORTUGUESES_FULFILLED';
export const FETCH_PORTUGUESES_REJECTED = 'FETCH_PORTUGUESES_REJECTED';